:host {
  --card-overflow: hidden;
}

div {
  display: flex;
  overflow: var(--card-overflow);
  width: auto;
  width: 256px; /* TODO: width must be 100% - must be handled in dashboard */
  height: 522px;
  box-sizing: border-box;
  flex-direction: column;
  border: var(--border-size-medium) solid var(--color-surface03);
  background-color: var(--color-surface01);
  border-radius: var(--border-radius);
}

div.real,
div.trial,
div.temp {
  border-color: var(--blue100);
}

/* HIDDEN status */
div.faded {
  border: var(--border-size-medium) solid var(--color-background);
}

/* HIGHLIGHTED status */
div.highlighted {
  box-shadow: var(--shadow-4);
  outline: none;
}

/* PRESSED status */
div.pressed {
  box-shadow: var(--shadow-8);
  outline: none;
}

div:focus {
  box-shadow: var(--shadow-focus-primary);
  outline: none;
}
